module.exports = __webpack_public_path__ + "images/emoji/balloon.0a44542a128e9ccd8718.png";